export default __webpack_public_path__ + "static/opera-37d40a444efa2fb84027d5b1f84181d8.png";